import { RESCUE_PLAN_TEMPLATES } from "@/lib/constants";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { LifeBuoy, ChevronDown } from "lucide-react";

/**
 * Drop-in button that lets the user pick a pre-canned rescue plan template
 * and inserts (or appends to) the current value via `onPick(newText)`.
 */
export default function RescuePlanTemplateMenu({ currentValue, onPick, testid = "rescue-template-menu" }) {
  const apply = (tpl, mode) => {
    if (mode === "replace" || !currentValue?.trim()) {
      onPick(tpl.text);
    } else {
      onPick(`${currentValue.trim()}\n\n${tpl.text}`);
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="border-slate-700 bg-slate-950 hover:bg-slate-800 text-xs h-7"
          data-testid={testid}
        >
          <LifeBuoy className="w-3.5 h-3.5 mr-1.5 text-blue-400" />
          Use Template
          <ChevronDown className="w-3 h-3 ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72">
        <DropdownMenuLabel className="text-xs uppercase tracking-wider">
          Rescue Plan Templates
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {RESCUE_PLAN_TEMPLATES.map((tpl) => (
          <div key={tpl.id} className="px-1 py-1">
            <div className="px-2 text-xs font-display font-bold text-slate-100 mb-1">
              {tpl.name}
            </div>
            <DropdownMenuItem
              onSelect={() => apply(tpl, "replace")}
              className="text-xs cursor-pointer"
              data-testid={`${testid}-${tpl.id}-replace`}
            >
              Replace current text
            </DropdownMenuItem>
            <DropdownMenuItem
              onSelect={() => apply(tpl, "append")}
              className="text-xs cursor-pointer"
              data-testid={`${testid}-${tpl.id}-append`}
            >
              Append to current text
            </DropdownMenuItem>
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
